
import React from 'react';
import VideoPlayer from './VideoPlayer';

interface Video {
  id: string;
  title: string;
  url: string;
  description?: string;
}

const videos: Video[] = [
  {
    id: '1',
    title: 'Community Outreach Program',
    url: 'https://dppptcbparmacmlpdqbn.supabase.co/storage/v1/object/public/images/video_2025-06-01_13-00-22.mp4',
    description: 'Our community members actively engaging with local leaders'
  },
  {
    id: '2', 
    title: 'Market Engagement Initiative',
    url: 'https://dppptcbparmacmlpdqbn.supabase.co/storage/v1/object/public/images/video_2025-06-01_13-00-55%20(1).mp4',
    description: 'Connecting with traders and market women to promote economic inclusion'
  },
  {
    id: '3',
    title: 'Cultural Heritage Day',
    url: 'https://dppptcbparmacmlpdqbn.supabase.co/storage/v1/object/public/images/video_2025-06-01_14-13-25.mp4',
    description: 'Celebrating our shared Yoruba identity through art, dance, and history'
  }
];

const VideoGallery: React.FC = () => {
  return (
    <section className="py-16 bg-slate-900/95">
      <div className="container-custom">
        <h2 className="section-title text-center mb-12 text-white drop-shadow-lg">Latest Videos</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <div key={video.id} className="space-y-4">
              <VideoPlayer 
                videoUrl={video.url}
                title={video.title}
                className="aspect-video"
              />
              {video.description && (
                <p className="text-slate-300 text-sm text-center px-2">
                  {video.description}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGallery;
